import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'api/models';
export const entriesFromAllocationsUrl = ({ startDate, ignoreSoftAllocation })=>{
    const formattedDate = moment(startDate).format(DEFAULT_DATE_FORMAT);
    return `/timesheets/${formattedDate}/allocations-entries-preview?ignoreSoftAllocation=${ignoreSoftAllocation ? 'true' : 'false'}`;
};
